const STATUS_ENDPOINT = 'https://eriks-order-console.onrender.com/public/delivery-status';
const instances = new Set();
let currentStatus = null;
let statusRequest = null;

function formatResumeTime(value) {
  const resumeAt = new Date(value);
  if (Number.isNaN(resumeAt.getTime())) return '';

  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).format(resumeAt);
}

function renderAll() {
  for (const instance of instances) instance.render(currentStatus);
}

async function refreshStatus() {
  if (statusRequest) return statusRequest;

  statusRequest = fetch(STATUS_ENDPOINT, {
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Delivery status failed with ${response.status}`);
      return response.json();
    })
    .then((payload) => {
      currentStatus = payload.delivery || null;
      renderAll();
    })
    .catch(() => {
      currentStatus = null;
      renderAll();
    })
    .finally(() => {
      statusRequest = null;
    });

  return statusRequest;
}

class EscDeliveryStatus extends HTMLElement {
  connectedCallback() {
    instances.add(this);
    this.render(currentStatus);
    void refreshStatus();
  }

  disconnectedCallback() {
    instances.delete(this);
  }

  render(status) {
    const paused = Boolean(status?.paused);
    this.hidden = !paused;
    if (!paused) return;

    const resumeTime = formatResumeTime(status.pausedUntil);
    const detail = this.querySelector('[data-esc-delivery-pause-detail]');
    if (!detail) return;
    detail.textContent = resumeTime
      ? `Delivery resumes ${resumeTime}. Store pickup is still available.`
      : 'Store pickup is still available.';
  }
}

if (!customElements.get('esc-delivery-status')) {
  customElements.define('esc-delivery-status', EscDeliveryStatus);
}

setInterval(() => void refreshStatus(), 60_000);
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) void refreshStatus();
});
